export default __webpack_public_path__ + "static/media/birthday.1770c357.jpg";